/**
 * Extract numeric facilityId from a facility URL path segment.
 * e.g., "great-value-storage-12345" → "12345"
 */
export function parseFacilityId(facilityPath) {
	if (!facilityPath) return null;
	let i = facilityPath.length - 1;
	while (i >= 0 && facilityPath[i] >= '0' && facilityPath[i] <= '9') {
		i--;
	}
	const digits = facilityPath.slice(i + 1);
	return digits.length > 0 ? digits : null;
}

/**
 * Extract PSP keyword from a storage-types URL slug.
 * Handles two patterns:
 *   "{keyword}-self-storage" → keyword  (e.g., "vehicle-self-storage" → "vehicle")
 *   "self-storage-{keyword}" → keyword  (e.g., "self-storage-for-boats" → "for-boats")
 */
export function parsePSPKeyword(pspSlug) {
	if (!pspSlug) return null;
	if (pspSlug.endsWith('-self-storage')) {
		return pspSlug.replace(/-self-storage$/, '');
	}
	if (pspSlug.startsWith('self-storage-')) {
		return pspSlug.replace(/^self-storage-/, '');
	}
	return pspSlug;
}

/**
 * Extract moveInStatus from a confirmation URL slug.
 * e.g., "confirm-success" → "success"
 */
export function parseMoveInStatus(confirmSlug) {
	if (!confirmSlug) return null;
	return confirmSlug.replace(/^confirm-/, '');
}
